import { useState, useCallback, useEffect } from "react";
import axios from "axios";

type SessionInfo = {
  documentCount: number;
  documentUrls: string[];
  documentType?: string;
};

export function useSessionInfo(sessionId?: string) {
  const [sessionInfo, setSessionInfo] = useState<SessionInfo | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSessionInfo = useCallback(async () => {
    if (!sessionId) return;
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/sessions/${sessionId}`);
      setSessionInfo(response.data);
    } catch (err) {
      setError("Impossible de charger les informations de session.");
    } finally {
      setIsLoading(false);
    }
  }, [sessionId]);

  useEffect(() => {
    fetchSessionInfo();
  }, [fetchSessionInfo]);

  return { sessionInfo, isLoading, error, fetchSessionInfo };
}
